const config = {
    apiUrl: process.env.NODE_ENV === 'production' ? `https://api.myweed.club` : `http://localhost:3013/api`,
    apiBasePath: process.env.NODE_ENV === 'production' ? '/' : '/api/',
};

export default config;